module.exports = __webpack_public_path__ + "static/media/nearshore-consulting.8906d4df.jpg";